"use strict";

import axios from "axios";
import { toast } from "react-toastify";

export const FETCH_CDG_LOAD_REQUESTS = "FETCH_CDG_LOAD_REQUESTS";
export const FETCH_CDG_LOAD_REQUESTS_SUCCESS =
  "FETCH_CDG_LOAD_REQUESTS_SUCCESS";
export const FETCH_CDG_LOAD_REQUESTS_ERROR = "FETCH_CDG_LOAD_REQUESTS_ERROR";

export const fetchCdgLoadRequests = (dataOptions) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CDG_LOAD_REQUESTS });
    try {
      const response = await axios.get(
        `/cdg_load_requests${dataOptions}`
      );
      dispatch({
        type: FETCH_CDG_LOAD_REQUESTS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      toast.error("Failed to fetch CDG load requests");
      dispatch({
        type: FETCH_CDG_LOAD_REQUESTS_ERROR,
        payload: error.message,
      });
    }
  };
};

export const submitCdgLoadRequests = (periods) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/cdg_load_requests/submit`, { periods });
      toast.success("Load request queried successfully");
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Authentication required. Please log in again.");
      } else if (error.response && error.response.status === 403) {
        toast.error("Access denied. You don't have permission to submit load request.");
      } else {
        toast.error("Failed to submit load request");
      }
      throw error;
    }
  };
};

export const createCdgLoadRequest = (id, totalLoad, curtailableLoad, submitBidToEmc = false, price = 0) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/cdg_load_requests/${id}/create`, { 
        total_load: totalLoad, 
        curtailable_load: curtailableLoad,
        submit_bid_to_emc: submitBidToEmc,
        price: price
      });
      toast.success("Load request created successfully");
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Authentication required. Please log in again.");
      } else if (error.response && error.response.status === 403) {
        toast.error("Access denied. You don't have permission to create load requests.");
      } else {
        toast.error("Failed to create load request");
      }
      throw error;
    }
  };
};

export const finalizeCdgLoadRequest = (id, curtailmentGranted) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/cdg_load_requests/${id}/finalize`, { 
        curtailment_granted: curtailmentGranted
      });
      toast.success("Load request finalized successfully");
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Authentication required. Please log in again.");
      } else if (error.response && error.response.status === 403) {
        toast.error("Access denied. You don't have permission to finalize load requests.");
      } else {
        toast.error("Failed to finalize load request");
      }
      throw error;
    }
  };
};

export const cancelCdgLoadRequest = (id) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/cdg_load_requests/${id}/cancel`);
      toast.success("Load request cancelled successfully");
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Authentication required. Please log in again.");
      } else if (error.response && error.response.status === 403) {
        toast.error("Access denied. You don't have permission to cancel load requests.");
      } else {
        toast.error("Failed to cancel load request");
      }
      throw error;
    }
  };
};

// Remove the import of addBid since we're handling bid creation in the backend
